import Image from 'next/image';
import React from 'react';
import ClientCarousel from '../home/client-carousel';
import ScheduleCall from '../common/schedule-call';

type Props = {
    path: any;
    alt: string;
    title: string;
    width: number;
    height: number;
    desc: string;
    className: string;
    children: any;
    isBg?: boolean;
};

const TechHeroSection: React.FC<Props> = ({ path, alt, title, width, height, children, desc, className, isBg }) => {
    return (
        <section className={`hero home-hero technology-herosection ${className}`}>
            <div className="container lg:container md:mx-auto top-hero">
                <div className="lg:grid hero-row gap-6 relative z-[1] h-full">
                    <div className="w-full">
                        <div className="inline-flex flex-col lg:items-start gap-5 hero-content justify-center h-full">
                            <h1 className="mb-0 dark:text-textcolor">{children}</h1>
                            <p className="mb-0 font-semibold text-secondary dark:text-secondary">{desc}</p>
                            <ScheduleCall />
                        </div>
                    </div>
                    <div className="text-center lg:text-start lg:self-center">
                        <div className="hero-tech-img">
                            {isBg ? (
                                <picture className="pic-bg">
                                    <source
                                        media="(max-width: 767px)"
                                        width={559}
                                        height={553}
                                        srcSet={`/img/hero/${path}-hero-bg-grunge-mobile@2x.webp`}
                                    />
                                    <source
                                        media="(max-width: 992px)"
                                        width={1032}
                                        height={1021}
                                        srcSet={`/img/hero/${path}-hero-bg-grunge.webp`}
                                    />
                                    <source
                                        media="(min-width: 1200px)"
                                        width={2063}
                                        height={2042}
                                        srcSet={`/img/hero/${path}-hero-bg-grunge@2x.webp`}
                                    />
                                    <Image
                                        width={1032}
                                        height={1021}
                                        src={`/img/hero/${path}-hero-bg-grunge.webp`}
                                        alt="bg pattern"
                                        loading="lazy"
                                    />
                                </picture>
                            ) : (
                                <></>
                            )}

                            <Image
                                src={`/img/hero/${path}@2x.webp`}
                                width={width}
                                height={height}
                                alt={alt}
                                title={title}
                                className="hero-vue-img z-[1]"
                                sizes="(max-width: 768px), 70vw (max-width: 1200px) 100vw"
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <ClientCarousel />
        </section>
    );
};

export default TechHeroSection;
